import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import LoaderOverlay from './../../../common/helper/loader.component.js';
import withAuth from './../../../common/helper/auth-component.js';
import AddApiKey from './add-key.component.js';
import ConfirmKey from './confirm-key.component.js';
import AddWebhooks from './add-webhooks.component.js';
import PayInPayOut from './payin-payout.component.js';
import Ipwhitelisting  from './ipwhitelisting.component.js';

import { toast } from 'react-toastify';
import Confirmation from '../../../common/modals/confirmation.component.js';
import ConfigurationService from '../../../../services/configuration-service.js';
import { initialFormData, initialErrors, fieldValidation  } from '../../../common/helper/form-constants.js';
import EditWebhooks from './edit-webhook.component.js';
import EditCallBack from './edit-callback.component.js';
import { MESSAGES } from '../../../constants/constants.js';


const GatewayConfiguration = () => {
    const [dataTableKey, setDataTableKey] = useState(0);
    const [activeTab, setActiveTab] = useState('api-key');
    const [apiKeyList, setApiKeyList] = useState([]);
    const [showEditWebModal, setShowEditWebModal] = useState(false)
    const [showEditPayinModal, setShowEditPayinModal] = useState(false)

    const [webhooksData, setWebhooksData] = useState([]);
    const [callbackData, setcallbackData] = useState([]);
    const [ipwhitelisting, setIpWhitelisting] = useState([]);


    const [modalShow, setModalShow] = React.useState(false);

    const [payinModalShow, setpayinModalShow]  = React.useState(false);
    const [ipModalShow, setIpModalShow]  = React.useState(false);

    const [keyModalShow, setKeyModalShow] = React.useState(false);
    const [hooksModalShow, sethooksModalShow] = React.useState(false);
    const [modalShowConfirmation , setModalShowConfirmation ] = React.useState(false);
    const [row, setRow] =  useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        whitelabel_tagline: '',
        whitelabel_display_name: ''
    })
    const [errors, setErrors] = useState({ ...initialErrors });
    const [imageUrl, setImageUrl] = useState('');


const getGatewayList = () => {
    setLoading(true);
    ConfigurationService.getGatewayInfo()
      .then(response => {
        const keyArr = [];
        const hooksArr = [];
        const callBackArr = [];
        if(response.data.data) {
          if(response.data.data.key_information && response.data.data.key_information.key_id) {
            keyArr.push(response.data.data.key_information);

          }
          if(response.data.data.webhook_information) {
            hooksArr.push(response.data.data.webhook_information)

          }
          if(response.data.data.callback_information) {
            callBackArr.push(response.data.data.callback_information)
          }
          if(response.data.data.ip_whitelist && response.data.data.ip_whitelist.length) {
            const ipItems = response.data.data.ip_whitelist.map(ip => ({ ip }));
            setIpWhitelisting(ipItems);
          }
            setApiKeyList(keyArr);
            setWebhooksData(hooksArr);
            setcallbackData(callBackArr)
            setFormData({
            whitelabel_display_name: response.data.data.whitelabel_information.whitelabel_display_name,
            whitelabel_tagline: response.data.data.whitelabel_information.whitelabel_tagline
        })
        if(response.data.data.whitelabel_information.whitelabel_logo) {
            const prefix = `data:};base64,`;
             const imageUrlWithPrefix = prefix + response.data.data.whitelabel_information.whitelabel_logo;
             setImageUrl(imageUrlWithPrefix);
          }
        }

        
        setLoading(false);
        
        //setImageUrl(response.data.data.qr[0].qr_image)
      })
      .catch(error => {
        console.log(error)
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });
}

    const deleteWebhooks = (row) => {
        setModalShowConfirmation (true);
         setRow({
          id: row.id,
            modalId: 'deleteWebhooks'
         })
       }

       const downloadKeys = (row) => {
        const csvData = [
            Object.keys(row).join(','), // Headers
            Object.values(row).join(',') // Values
        ].join('\n');
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'keys.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const columns = [
        {
          name: 'Key Id',
          selector: row => row.key_id,
          sortable: true,
        },
        {
          name: 'Expiry',
          selector: row => 'Never',//row.expiry,
          sortable: true,
        },
        {
          name: 'Created At',
          selector: row => row.key_created_on,
          sortable: true,
        },
        {
          name: 'Updated At',
          selector: row => row.key_updated_on,
          sortable: true,
        },
        {
          name: 'Actions',
          style: row => ({ minWidth: '23%' }),
          selector: row => <>

      

           <a className="flock tooltip" href="#" onClick={() => {
          confirmKeyGen();
        }}>
           {/* <a className={`fview tooltip}`} style={{'cursor':'pointer'}}  onClick={() => ViewAgent(row.user_id)}>
         <i className={`fa fa-download`} style={{ color: row.user_id && !!expanded[row.user_id] ? 'white' : 'black' }}/>
          <span className="tooltiptext">View</span>
        </a> */}
            
            <button className="btn btn-success ddfg modal__button regentrae-key" id="open-modalg" style={{color: '#3280dd!important', backgroundColor: 'white!important', border: '1px solid #65c5ff', fontSize: '12px'}}>
            <i className="fa fa-refresh" style={{color: '#3280dd', marginRight: '7px'}} />Regenerate</button>
            {/* <span class="tooltiptext">Lock</span> */}
      </a>
          
          </>
        },
      ];

      const changeStatusWeb = () => {
        setModalShowConfirmation(true)
        setRow({
          id: row.id,
          status: row.status_id,
          modalId: 'statusChangeWeb'
        })
      }

      const checkStatus = (name,row) => {
        if(name == 'A') {
  
          return (<label className="switch" onClick={(event) => {
            event.preventDefault(); // Prevent the default action
            changeStatusWeb(row); // Call your changeStatus function
          }}>
          <input type="checkbox" className="switch-input"  checked />
          <span className="switch-label" data-on="Active" data-off="Deactive" />
          <span className="switch-handle" />
        </label>)
        } else {
          return (
  
            <div data-tag="allowRowEvents"><label className="switch" onClick={(event) => {
              event.preventDefault(); // Prevent the default action
              changeStatusWeb(row); // Call your changeStatus function
            }}><input type="checkbox" className="switch-input" /><span className="switch-label" data-on="Active" data-off="Deactive" /><span className="switch-handle" /></label></div>
          );
        }
    }

    const updateStatus = () => {
        setLoading(true);
        let data = {};
        if(row.status_id == 'A') {
            data.status = 'S'
        }else{
            data.status = 'A'
        }
        ConfigurationService.updateWebHookStatus(data)
        .then(response => {
          toast.success(MESSAGES.PAYMENT_DEL)
          listPayments();
          setModalShow(false)
          setLoading(false);
    
        })
        .catch(error => {
          setLoading(false);
          try {
            const errorMessage = error.response.data
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          } catch (e){
            toast.error( MESSAGES.SERVER_ERROR)
          }
        });
    }

    const webhooks = [
        {
            name: 'Success URL',
            selector: row => row.webhook_url_success,
            sortable: true,
          },
          {
            name: 'Pending URL',
            selector: row => row.webhook_url_pending,
            sortable: true,
          },
          {
            name: 'Fail URL',
            selector: row => row.webhook_url_fail,
            sortable: true,
          },
          {
            name: 'Created At',
            selector: row => row.webhook_created_on,
            sortable: true,
          },
          {
            name: 'Updated At',
            selector: row => row.webhook_updated_on,
            sortable: true,
          },
          {
            name: 'Actions',
            selector: row => <>
             <a className="fedit tooltip modal__button" style={{backgroundColor: 'transparent'}} href="#" id="open-modalww" onClick={editWebhook}>
                <i className="fa fa-edit" style={{color:'black'}}/>
                <span className="tooltiptext">Edit</span>
                </a>
                {/* <a className="ftrash tooltip btn_webhooks_delete_details" href="#" onClick={() => {
          deleteWebhooks();
        }}>
                <i className="fa fa-trash" style={{color:'black'}}/>
                <span className="tooltiptext">Delete</span>
                </a> */}
            
            </>
          },
    ]
    
    const callbackCols = [
      {
        name: 'PayIn Success URL',
        cell: row => <div className="custom-cell-fullName">{row.call_back_payin_url_success}</div>,
        sortable: true,
      },
      {
        name: 'PayIn Pending URL',
        cell: row => <div className="custom-cell-fullName">{row.call_back_payin_url_pending}</div>,
        sortable: true,
      },
      {
        name: 'PayIn Fail URL',
        cell: row => <div className="custom-cell-fullName">{row.call_back_payin_url_fail}</div>,
        sortable: true,
      },
      {
        name: 'PayOut Success URL',
        cell: row => <div className="custom-cell-fullName">{row.call_back_payout_url_success}</div>,
        sortable: true,
      },
      {
        name: 'PayOut Pending URL',
        cell: row => <div className="custom-cell-fullName">{row.call_back_payout_url_pending}</div>,
        sortable: true,
      },
      {
        name: 'PayOut Fail URL',
        cell: row => <div className="custom-cell-fullName">{row.call_back_payout_url_fail}</div>,
        sortable: true,
      },
      {
        name: 'Actions',
        selector: row => <>
         <a className="fedit tooltip modal__button" style={{backgroundColor: 'transparent'}} href="#" id="open-modalww" onClick={editCallback}>
            <i className="fa fa-edit" style={{color:'black'}}/>
            <span className="tooltiptext">Edit</span>
            </a>
            {/* <a className="ftrash tooltip btn_webhooks_delete_details" href="#" onClick={() => {
      deleteWebhooks();
    }}>
            <i className="fa fa-trash" style={{color:'black'}}/>
            <span className="tooltiptext">Delete</span>
            </a> */}
        
        </>
      },

    ]
    const editCallback = () => {
      setShowEditPayinModal(true);
      setRow({
          modalId: 'editCallback'
      })
    }
    const editWebhook = () => {
        setShowEditWebModal(true);
        setRow({
            modalId: 'editWebhook'
        })
    }


    const submitApiKey = (formData) => {
        const requestData = {
            key_information: formData
            // Add other properties if needed
        };
        setLoading(true);
        ConfigurationService.createGateway(requestData)
          .then(response => {
            getGatewayList();
            toast.success(MESSAGES.KEY_CREATE)
            setLoading(false);
            setModalShow(false);
            getGatewayList();

          })
          .catch(error => {
            console.log(error)
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
      
    }  
    const submitConfirmKey =(formData) => {
        setLoading(true);

        formData.key_id = apiKeyList[0].key_id
        const requestData = {
            key_information : formData
        }
        ConfigurationService.createGateway(requestData)
          .then(response => {
            getGatewayList();
            toast.success(MESSAGES.KEY_UPDATE)
            setLoading(false);
            setKeyModalShow(false)
          })
          .catch(error => {
            console.log(error)
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
    }

    const submitPayIn=(formData) => {
      console.log(formData)
        const requestData = {
            callback_information: {
              call_back_payin_url_success : formData.webhook_url,
              call_back_payin_url_pending : formData.webhook_alert_email,
              call_back_payin_url_fail : formData.webhook_secret,
              call_back_payout_url_success : formData.webhook_url_payout,
              call_back_payout_url_pending : formData.webhook_alert_email_payout,
              call_back_payout_url_fail : formData.webhook_secret_payout,
            }
            // Add other properties if needed
        };
        setLoading(true);
        ConfigurationService.createGateway(requestData)
          .then(response => {
            getGatewayList();
            if(row.modalId == 'editCallback') {
                toast.success(MESSAGES.CALLBACK_URL_CREATE)
            } else {
                toast.success(MESSAGES.CALLBACK_URL_UPDATE)
            }
           
            setLoading(false);
            setpayinModalShow(false)
            setShowEditPayinModal(false)
          })
          .catch(error => {
            console.log(error)
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
    }


    const submitWebhooks =(formData) => {
      console.log(formData)
        const requestData = {
            webhook_information: {
              webhook_url_success : formData.webhook_url,
              webhook_url_pending : formData.webhook_alert_email,
              webhook_url_fail : formData.webhook_secret
            }
            // Add other properties if needed
        };
        setLoading(true);
        ConfigurationService.createGateway(requestData)
          .then(response => {
            getGatewayList();
            if(row.modalId == 'editWebhook') {
                toast.success(MESSAGES.HOOK_UPDATE)
            } else {
                toast.success(MESSAGES.HOOK_CREATE)
            }
           
            setLoading(false);
            sethooksModalShow(false)
            setShowEditWebModal(false)
          })
          .catch(error => {
            console.log(error)
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
    }


    const submitIpWhitelisting = (ips) => {
        const requestData = {
            ip_whitelist: ips
        };
        setLoading(true);
        ConfigurationService.createGateway(requestData)
          .then(response => {
            getGatewayList();
            toast.success('IP Whitelisting updated successfully.');
            setLoading(false);
            setIpModalShow(false);
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data;
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
            } catch (e) {
              toast.error(MESSAGES.SERVER_ERROR);
            }
          });
    };

    const ipWhitelistCols = [
        {
            name: 'IP Address',
            selector: row => row.ip,
            sortable: true,
        },
    ];

    const addNewKey = (row) => {
     
        setModalShow(true)
        // setRow({
        //   id: row.id,
        //   modalId: 'addApiKey'
        // })
      }
      const confirmKeyGen = () => {
        setKeyModalShow(true)
      }

      const showWebhooks = () => {
        sethooksModalShow(true);
        setRow({
            modalId: 'addWebhook'
        })
      }

      const showPayIn = () => {
        setpayinModalShow(true);
        setRow({
            modalId: 'payin'
        })
      }

      const showIPListing = () => {
        setIpModalShow(true);
        setRow({
            modalId: 'ipListing'
        })
      }

      

 
      
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    console.log(errorMessage)
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage
  };

  const updateWebhooks = (e) => {
    e.preventDefault();
    let hasError;
    Object.keys(formData).forEach(fieldName => {
        const error = validateField(fieldName, formData[fieldName]);
        if (error) {
          hasError = true;
        }
    });
    if (!imageUrl) {
        toast.error(MESSAGES.UPLOAD_IMG);
        return;
      }
    if(!hasError) {
        setLoading(true);
        formData.whitelabel_logo = imageUrl.split(',')[1];
        const requestData = {
            whitelabel_information: formData
            // Add other properties if needed
        };
        ConfigurationService.createGateway(requestData)
          .then(response => {
            getGatewayList();
            toast.success(MESSAGES.GATEWAY_CREATE)
            setLoading(false);
            sethooksModalShow(false)
          })
          .catch(error => {
            console.log(error)
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
    }
  }
     
    useEffect(() => {
        getGatewayList();
        document.body.style.backgroundImage = '';

        document.body.style.backgroundColor = '#f0f6fa';
        
        return () => {
          document.body.style.backgroundColor = '';
        };
      }, []);

      const handleFileChange  = () => {
        const file = event.target.files[0];
        const maxSize = 2 * 1024 * 1024; // 2 MB

        if (!file.type || !file.type.startsWith('image/')) {
          toast.error('Please select an image file.');
          return;
        }

        if (file && file.size <= maxSize) {
          const reader = new FileReader();
          reader.onload = () => {
            setImageUrl(reader.result);
          };
          reader.readAsDataURL(file);
        } else {
          setImageUrl('');
          toast.error('File size exceeds 2 MB. Please select a smaller file.');
        }

      }



return(
    <>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Merchants Getway Configuration</h4>
    <div className="container" style={{backgroundColor: 'white'}}>
      <nav>
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button className={`nav-link tbbtn ${activeTab === 'api-key' ? 'active' : ''}`} type="button" onClick={() => setActiveTab('api-key')}>Api key</button>
          <button className={`nav-link tbbtn ${activeTab === 'web-routing' ? 'active' : ''} ${apiKeyList.length === 0 ? 'disable' : ''}`} type="button" onClick={() => apiKeyList.length && setActiveTab('web-routing')}>Web Routing</button>
          <button className={`nav-link tbbtn ${activeTab === 'callbacks' ? 'active' : ''} ${apiKeyList.length === 0 ? 'disable' : ''}`} type="button" onClick={() => apiKeyList.length && setActiveTab('callbacks')}>CallBacks</button>
          <button className={`nav-link tbbtn ${activeTab === 'ip-whitelist' ? 'active' : ''} ${apiKeyList.length === 0 ? 'disable' : ''}`} type="button" onClick={() => apiKeyList.length && setActiveTab('ip-whitelist')}>IP Whitelisting</button>
          <button className={`nav-link tbbtn ${activeTab === 'white-labels' ? 'active' : ''} ${apiKeyList.length === 0 ? 'disable' : ''}`} type="button" onClick={() => apiKeyList.length && setActiveTab('white-labels')}>White Labels</button>
        </div>
      </nav>
      <div style={{paddingTop: '15px', paddingBottom: '15px'}}>
        {activeTab === 'api-key' && (
          <div>
            {apiKeyList && apiKeyList.length == 0 && (
              <div className="container mgj" style={{padding: 0, paddingRight: '8px'}}>
                <div className="col-md-12 adddgents" style={{textAlign: 'right', marginBottom: '10px'}}>
                  <button className="btn btn-success ddfg modal__button" style={{color: 'white', backgroundColor: '#65c5ff', border: '1px solid #65c5ff', fontSize: '13px'}} onClick={() => addNewKey()}>Add New Api Key</button>
                </div>
              </div>
            )}
            <div className="dataTables_wrapper dt-jqueryui no-footer">
              <DataTable columns={columns} data={apiKeyList} key={dataTableKey} />
            </div>
          </div>
        )}
        {activeTab === 'web-routing' && (
          <div>
            {webhooksData && webhooksData.length == 0 && (
              <div className="container mgj" style={{padding: 0, paddingRight: '8px'}}>
                <div className="col-md-12 adddgents" style={{textAlign: 'right', marginBottom: '10px'}}>
                  <button className="btn btn-success ddfg modal__button" style={{color: 'white', backgroundColor: '#65c5ff', border: '1px solid #65c5ff', fontSize: '13px'}} onClick={showWebhooks}>Add New Web Routing</button>
                </div>
              </div>
            )}
            <div className="dataTables_wrapper dt-jqueryui no-footer">
              <DataTable columns={webhooks} data={webhooksData} key={dataTableKey} />
            </div>
          </div>
        )}
        {activeTab === 'callbacks' && (
          <div>
            {callbackData && callbackData.length == 0 && (
              <div className="container mgj" style={{padding: 0, paddingRight: '8px'}}>
                <div className="col-md-12 adddgents" style={{textAlign: 'right', marginBottom: '10px'}}>
                  <button className="btn btn-success ddfg modal__button" style={{color: 'white', backgroundColor: '#65c5ff', border: '1px solid #65c5ff', fontSize: '13px'}} onClick={showPayIn}>Add New Pay In &amp; Pay Out</button>
                </div>
              </div>
            )}
            <div className="dataTables_wrapper dt-jqueryui no-footer">
              <DataTable columns={callbackCols} data={callbackData} key={dataTableKey} />
            </div>
          </div>
        )}
        {activeTab === 'ip-whitelist' && (
          <div>
            <div className="container mgj" style={{padding: 0, paddingRight: '8px'}}>
              <div className="col-md-12 adddgents" style={{textAlign: 'right', marginBottom: '10px'}}>
                <button className="btn btn-success ddfg modal__button" style={{color: 'white', backgroundColor: '#65c5ff', border: '1px solid #65c5ff', fontSize: '13px'}} onClick={showIPListing}>Add IP Whitelisting</button>
              </div>
            </div>
            <div className="dataTables_wrapper dt-jqueryui no-footer">
              <DataTable columns={ipWhitelistCols} data={ipwhitelisting} key={dataTableKey} />
            </div>
          </div>
        )}
        {activeTab === 'white-labels' && (
          <form onSubmit={updateWebhooks}>
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{padding: 0}}>
                  <div className="col-md-5" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">DISPLAY NAME</label>
                      <input type="text" onChange={handleChange} value={formData.whitelabel_display_name} className={`form-control ${errors.whitelabel_display_name ? 'is-invalid' : ''}`} id="first_name" name="whitelabel_display_name" />
                      {errors.whitelabel_display_name && <div className="invalid-feedback">{errors.whitelabel_display_name}</div>}
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">TAGLINE</label>
                      <input type="text" onChange={handleChange} value={formData.whitelabel_tagline} className={`form-control ${errors.whitelabel_tagline ? 'is-invalid' : ''}`} id="first_name" name="whitelabel_tagline" />
                      {errors.whitelabel_tagline && <div className="invalid-feedback">{errors.whitelabel_tagline}</div>}
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">UPLOAD LOGO</label>
                      <input style={{width: '85%', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name" onChange={handleFileChange} />
                      {imageUrl ? (
                        <img src={imageUrl} alt="no image" className="image-preview vjk" />
                      ) : (
                        <img src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                      )}
                    </div>
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="submit" name="btn_admin_details" id="btn_basics_details" className="btn ddfg sebtn whitelabels">Submit</button>
                </div>
                <br />
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
    <AddApiKey  show={modalShow} onHide={() => setModalShow(false)} onSubmit={(formData) => submitApiKey(formData)} status={row.status} modalId = {row.modalId}/>
    <ConfirmKey  show={keyModalShow} onHide={() => setKeyModalShow(false)}  onSubmit={(formData) => submitConfirmKey(formData)}  status={row.status} modalId = {row.modalId}/>

    <AddWebhooks  show={hooksModalShow} onHide={() => sethooksModalShow(false)} onSubmit={(formData) => submitWebhooks(formData)} status={row.status} modalId = {row.modalId} data = {webhooksData[0]} />

    <PayInPayOut  show={payinModalShow} onHide={() => setpayinModalShow(false)} onSubmit={(formData) => submitPayIn(formData)} status={row.status} modalId = {row.modalId} data = {callbackData[0]} />

    <Ipwhitelisting  show={ipModalShow} onHide={() => setIpModalShow(false)} onSubmit={(ips) => submitIpWhitelisting(ips)} status={row.status} modalId = {row.modalId} />
    

    <Confirmation  show={modalShowConfirmation} onHide={() => setModalShowConfirmation(false)} onSave={() => updateStatus(false)} status={row.status} modalId = {row.modalId}/>

    {webhooksData && webhooksData.length > 0 && (
    <EditWebhooks  show={showEditWebModal} onHide={() => setShowEditWebModal(false)} onSubmit={(formData) => submitWebhooks(formData)} status={row.status} modalId = {row.modalId} data = {webhooksData[0]} />
    )}

{callbackData && callbackData.length > 0 && showEditPayinModal &&(
    <EditCallBack  show={showEditPayinModal} onHide={() => setShowEditPayinModal(false)} onSubmit={(formData) => submitPayIn(formData)} status={row.status} modalId = {row.modalId} data = {callbackData[0]} />

    
    )}
  </div>
  </>
)

}
    function mapStateToProps(state) {
        const userData = state.authReducer.user;
        return { userData };
      }
    export default withAuth(connect(mapStateToProps)(GatewayConfiguration));